import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';

export const PAGES_SET_PAGE = 'PAGES_SET_PAGE';

const initialState = {};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case PAGES_SET_PAGE:
      return {
        ...state,
        [payload.slug]: payload.page
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function setPage(slug, page) {
  return {type: PAGES_SET_PAGE, payload: {slug, page}};
}

export function fetchPage(slug) {
  return dispatch => {
    dispatch(setPage(slug, null));

    return dispatch(api.get(`pages/by-slug/${slug}`))
      .then(pageResponse => {
        dispatch(setPage(slug, pageResponse.content));
        return pageResponse.content;
      })
      .catch(err => {
        if (err.status === 404) {
          dispatch(setPage(slug, false));
        }

        throw err;
      })
  }
}



// WEBPACK FOOTER //
// ./ducks/pages.js